package com.kanati.admin.state

import kotlinx.browser.window

private const val ADMIN_SESSION_TOKEN_KEY = "kanati.admin.accessToken"

actual object AdminSessionTokenStore {
    actual fun load(): String? = window.localStorage.getItem(ADMIN_SESSION_TOKEN_KEY)

    actual fun save(token: String) {
        window.localStorage.setItem(ADMIN_SESSION_TOKEN_KEY, token)
    }

    actual fun clear() {
        window.localStorage.removeItem(ADMIN_SESSION_TOKEN_KEY)
    }
}
